module.exports = __webpack_public_path__ + "img/2.d76d3653.png";